import { MeetingState } from './types';
import { RootState } from 'store/root-reducer';
import { createSelector } from '@reduxjs/toolkit';

const selectMeetingReducer = (state: RootState): MeetingState => state.meeting;

export const selectBlurActive = createSelector([selectMeetingReducer], (meeting) => meeting.blurActive);
export const selectMeetingMode = createSelector([selectMeetingReducer], (meeting) => meeting.meetingMode);
